import io from 'socket.io-client';
import { ApiUrl } from './store/config';

// Get base URL (remove /api suffix)
const baseURL = ApiUrl.replace('/api', '');
console.log('[Socket] Connecting to:', baseURL);

// Helper to get userId from JWT token in localStorage
const getUserIdFromToken = () => {
  try {
    const token = localStorage.getItem('token');
    if (!token) return null;
    // JWT format: header.payload.signature - decode payload (base64)
    const payload = JSON.parse(atob(token.split('.')[1]));
    return payload._id || payload.id || payload.userId;
  } catch (e) {
    console.error('[Socket] Failed to decode token:', e);
    return null;
  }
};

// Create and export socket connection immediately at module load
// Using io.connect() for socket.io-client v2.x compatibility (matches backend v2.3.0)
// Start with polling first, then upgrade to websocket (more reliable)
const socket = io.connect(baseURL, {
  transports: ['polling', 'websocket'],
  reconnection: true,
  reconnectionAttempts: 5,
  reconnectionDelay: 1000,
  upgrade: true
});

socket.on('connect', () => {
  console.log('[Socket] Connected, ID:', socket.id);

  // Register user immediately on connect
  const userId = getUserIdFromToken();
  if (userId) {
    socket.emit('register', { userId });
    console.log('[Socket] Registered user:', userId);
  } else {
    console.log('[Socket] No userId found in token, skipping register');
  }
});

socket.on('disconnect', (reason) => {
  console.log('[Socket] Disconnected:', reason);
});

socket.on('connect_error', (error) => {
  console.error('[Socket] Connection error:', error.message);
});

// Function to register user after login (when token becomes available)
export const registerSocketUser = () => {
  const userId = getUserIdFromToken();
  if (userId && socket.connected) {
    socket.emit('register', { userId });
    console.log('[Socket] Registered user after login:', userId);
  } else if (userId && !socket.connected) {
    // If not connected, wait for connection then register
    socket.once('connect', () => {
      socket.emit('register', { userId });
      console.log('[Socket] Registered user after reconnect:', userId);
    });
  }
};

export default socket;
